import React from "react";
import { Field, FieldArray } from "formik";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";
import Select from "components/Form/Select";
import AsyncFilterSelect from "components/Form/AsyncFilterSelect";
import { doctorHandleInputChange } from "utils/selectOptions";
import AddCarbonCopie from "components/Form/AddCarbonCopie";
import { Grid, Icon, Segment } from "semantic-ui-react";
import { cleanPhoneNumber } from "utils/phone";
import Separator from "components/Form/Separator";
import { Checkbox } from "components/Form/SpecialButtons";
import InputPhone from "components/Form/InputPhone";
import RedButton from "components/Buttons/RedButton";
import MultipleSelect from "features/Admin/components/NewMultipleSelect";

const GeneralForm = ({
	packsCampaigns,
	values,
	setFieldValue,
	disabled,
	handleChange,
	filterCompany,
	filterDoctors,
	centersFactory,
	updateCenters,
}) => (
	<div>
		<Field customlabel="Active" component={Checkbox} name="status" id="status" />
		<Field type="text" name="name" customlabel="Nom de la campagne" component={CustomInputTextComponent} required />
		<Field type="text" name="abbreviation" customlabel="Code" component={CustomInputTextComponent} required />
		<Field type="text" name="reference" customlabel="Référence" component={CustomInputTextComponent} />
		<div style={{ margin: "5px 0" }}>
			<MultipleSelect factory={centersFactory} update={updateCenters} />
		</div>
		<Field type="text" name="templateEmail" customlabel="Template de l'email envoyé" component={CustomInputTextComponent} />
		<Field
			component={Select}
			name="analyses_pack"
			customlabel="Pack d'analyses"
			placeholder="Sélectionner un pack d'analyses"
			isClearable={true}
			options={
				packsCampaigns
					? packsCampaigns.map((pack) => {
							return {
								value: pack.id,
								label: `${pack.label} (${pack.analysesPackages?.flatMap((ap) => ap.analysis?.code).join(", ")})`,
							};
					  })
					: []
			}
			required
		/>

		<Field
			component={AsyncFilterSelect}
			defaultValue={values.billing_company}
			name="billing_company"
			customlabel="Société de facturation"
			promiseOptions={(searchTerm, callback) => {
				return filterCompany(searchTerm, callback);
			}}
			placeholder="Sélectionner une société"
			isClearable={true}
			onClear={() =>
				setFieldValue("billing_company", {
					id: null,
				})
			}
			customOnChange={(option) => {
				setFieldValue("billing_company", option);
			}}
		/>

		<Field
			component={AsyncFilterSelect}
			defaultValue={values.prescriber}
			name="prescriber"
			customlabel="Médecin prescripteur"
			promiseOptions={(searchTerm, callback) => {
				return filterDoctors(searchTerm, callback);
			}}
			onInputChange={doctorHandleInputChange}
			placeholder="Sélectionner un médecin"
			isClearable={true}
			customOnChange={(option) => {
				setFieldValue("prescriber", option);
			}}
			onClear={() =>
				setFieldValue("prescriber", {
					id: null,
				})
			}
		/>
		<Segment>
			<AddCarbonCopie
				customlabel="Ajouter un médecin en copie"
				onClick={() => {
					setFieldValue("carbonCopyDoctors", [...values.carbonCopyDoctors, null]);
				}}
				disabled={disabled}
				type="button"
			/>

			<FieldArray
				name="carbonCopyDoctors"
				render={() => {
					return values.carbonCopyDoctors.map((doctor, index) => (
						<Grid columns={2} key={`ccform-${index}`}>
							<Separator />
							<Grid.Column mobile={16} tablet={16} computer={16}>
								<Field
									component={AsyncFilterSelect}
									name={`carbonCopyDoctors.${index}.doctor`}
									customlabel={`Ajouter un médecin en copie (${index + 1})`}
									promiseOptions={(searchTerm, callback) => {
										return filterDoctors(searchTerm, callback);
									}}
									onInputChange={doctorHandleInputChange}
									disabled={disabled}
									customOnChange={(option) => {
										setFieldValue(`carbonCopyDoctors.${index}.doctor`, option);
										setFieldValue(`carbonCopyDoctors.${index}.to_be_phoned`, false);
										setFieldValue(`carbonCopyDoctors.${index}.to_be_phoned_number`, "");
										setFieldValue(`carbonCopyDoctors.${index}.to_be_faxed`, false);
										setFieldValue(`carbonCopyDoctors.${index}.to_be_faxed_number`, "");
									}}
								/>
							</Grid.Column>

							<Grid.Column mobile={16} tablet={8} computer={8}>
								<Field
									customlabel="Par téléphone"
									component={Checkbox}
									name={`carbonCopyDoctors.${index}.to_be_phoned`}
									id={`carbonCopyDoctors.${index}.to_be_phoned`}
									disabled={disabled || !values.carbonCopyDoctors[index]?.doctor}
									onChange={(e) => {
										handleChange(e);
										if (values.carbonCopyDoctors[index]?.to_be_phoned) {
											setFieldValue(`carbonCopyDoctors.${index}.to_be_phoned_number`, "");
										} else {
											setFieldValue(
												`carbonCopyDoctors.${index}.to_be_phoned_number`,
												cleanPhoneNumber(values.carbonCopyDoctors[index]?.doctor?.phone)
											);
										}
									}}
								/>
								{values.carbonCopyDoctors[index]?.to_be_phoned && (
									<div style={{ marginBottom: 20 }}>
										<Field
											component={InputPhone}
											name={`carbonCopyDoctors.${index}.to_be_phoned_number`}
											id={`carbonCopyDoctors.${index}.to_be_phoned_number`}
											customlabel="Numéro"
											required
											disabled={disabled}
										/>
									</div>
								)}
							</Grid.Column>
							<Grid.Column mobile={16} tablet={8} computer={8}>
								<Field
									customlabel="Par fax"
									component={Checkbox}
									name={`carbonCopyDoctors.${index}.to_be_faxed`}
									id={`carbonCopyDoctors.${index}.to_be_faxed`}
									disabled={disabled || !values.carbonCopyDoctors[index]?.doctor}
									onChange={(e) => {
										handleChange(e);
										if (values.carbonCopyDoctors[index]?.to_be_faxed) {
											setFieldValue(`carbonCopyDoctors.${index}.to_be_faxed_number`, "");
										} else {
											setFieldValue(`carbonCopyDoctors.${index}.to_be_faxed_number`, cleanPhoneNumber(values.carbonCopyDoctors[index]?.doctor?.fax));
										}
									}}
								/>
								{values.carbonCopyDoctors[index]?.to_be_faxed && (
									<div style={{ marginBottom: 20 }}>
										<Field
											component={InputPhone}
											name={`carbonCopyDoctors.${index}.to_be_faxed_number`}
											id={`carbonCopyDoctors.${index}.to_be_faxed_number`}
											customlabel="Numéro"
											required
											disabled={disabled}
										/>
									</div>
								)}
							</Grid.Column>

							<Grid.Column mobile={16} tablet={16} computer={16}>
								<RedButton
									text={<Icon name="trash" />}
									type="button"
									onClick={(e) => {
										if (e !== undefined) e.preventDefault();
										values.splice(index, 1);
										setFieldValue("carbonCopyDoctors", values.carbonCopyDoctors);
									}}
									style={{ width: "100%" }}
									disabled={disabled}
								>
									Supprimer le docteur en copie
								</RedButton>
							</Grid.Column>
						</Grid>
					));
				}}
			/>
		</Segment>
	</div>
);

export default GeneralForm;
